import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import ActivitySummary from './ActivitySummary.jsx';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import { useStateValue } from '../context/state.jsx';
import { setBulkActivities } from '../context/bulk.js';

const ActivityGroup = ({
	activities,
	datasetInfo,
	className
}) => {
	const [{ isBulkActive, bulkActivities }, dispatch] = useStateValue();

	const handleClick = (activityId, e) => {
		if (isBulkActive) {
			e.preventDefault();
			updateBulkActivities(activityId);
		}
	};

	const updateBulkActivities = activityId => {
		const bulkActivitiesTemp = [...bulkActivities],
			i = bulkActivitiesTemp.indexOf(activityId);

		if (i > -1) {
			bulkActivitiesTemp.splice(i, 1);
		} else {
			bulkActivitiesTemp.push(activityId);
		}

		dispatch(setBulkActivities(bulkActivitiesTemp));
	};

	if (!activities.length) {
		return null;
	}

	let activitiesList = null;
	activitiesList = activities.map(activity => {
		return (
			<ListGroupItem
				key={activity.activityId}
				className="activityGroupListItem">
				<input
					id={`multi-${activity.activityId}`}
					className="bulk-checkbox"
					type="checkbox"
					checked={bulkActivities.indexOf(activity.activityId) > -1}
					onChange={() => { updateBulkActivities(activity.activityId); }} />
				<Link
					onClick={e => { handleClick(activity.activityId, e); }}
					to={`/app/dataset/${datasetInfo.Id}/activity/${activity.activityId}/`}>
					<ActivitySummary
						activity={activity}
						datasetInfo={datasetInfo} />
				</Link>
			</ListGroupItem>
		);
	});
	const classNames = classnames('activityGroupList', className);

	return (
		<ListGroup
			className={classNames}>
			{activitiesList}
		</ListGroup>
	);
};

ActivityGroup.propTypes = {
	activities: PropTypes.array.isRequired,
	datasetInfo: PropTypes.object.isRequired,
	className: PropTypes.string
};

export default ActivityGroup;